<template>
    <section class="">
      <div class="text-center">
        <div class="tok-img flex justify-center">
          <img src="images/htb.png">
        </div>
        <!-- <div class="copy-address flex mt-10 justify-center">
          <div :class="{ 'address': true, 'clicked': isClicked }" @click="copyToClipboard">
            $AKITTY: asdfafsadffssdf
            <ClipboardDocumentCheckIcon class="pl-2 h-6 w-6 text-white-500" />
          </div>
        </div> -->
      </div>
    </section>
  </template>
  
  <script>
//   import { ClipboardDocumentCheckIcon } from "@heroicons/vue/24/solid";
  
  export default {
    name: 'HowBuy',
  
    // data() {
    //   return {
    //     textToCopy: "abc",
    //     isClicked: false, // Add a data property to track if the button is clicked
    //   };
    // },
    // methods: {
    //   copyToClipboard() {
    //     // Create a temporary textarea element
    //     const textarea = document.createElement("textarea");
    //     textarea.value = this.textToCopy;
    //     // Make the textarea out of viewport
    //     textarea.style.position = "fixed";
    //     textarea.style.opacity = 0;
    //     document.body.appendChild(textarea);
    //     // Select the text and copy it to the clipboard
    //     textarea.select();
    //     document.execCommand("copy");
    //     // Clean up - remove the temporary textarea
    //     document.body.removeChild(textarea);
    //     // Optionally, show a message or perform any other action upon copying
    //     console.log("Text copied:", this.textToCopy);
  
    //     // Update the isClicked property to true
    //     this.isClicked = true;
    //   },
    // },
    // components: {
    //   ClipboardDocumentCheckIcon
    // }
  };
  </script>
  
  <style>
  .address {
    display: inline-block;
    padding: 10px 20px;
    border: none;
    border-radius: 20px; /* Adjust the value as needed for the desired roundness */
    background-color: #000; /* Set your desired background color */
    color: #FFF; /* Set your desired text color */
    cursor: pointer;
    transition: background-color 0.3s, color 0.3s;
    display: flex;
  }
  
  .address:hover {
    background-color: #28a6db; /* Set your desired background color on hover */
  }
  
  .address.clicked {
    background-color: green; /* Set your desired background color on click */
  }
  
  </style>
  